type BuffedEmitterProps<T> = {
  action: (buffer: T[]) => Promise<void> | void;
  emitInterval?: number;
  maxItems?: number;
};

export class BufferedEmitter<T> {
  private action: (buffer: T[]) => Promise<void> | void;
  private buffer: T[];
  private intervalTimeoutId: NodeJS.Timeout | number | string | undefined;
  emitInterval: number;
  maxItems: number;

  constructor({ action, emitInterval, maxItems }: BuffedEmitterProps<T>) {
    this.buffer = [];
    this.emitInterval = emitInterval || 300;
    this.maxItems = maxItems || 10;
    this.action = action;
    this.flush(this.buffer);
  }

  private async flush(items: T[] = []): Promise<void> {
    this.intervalTimeoutId && clearTimeout(this.intervalTimeoutId);
    this.intervalTimeoutId = setTimeout(() => {
      this.flush(this.buffer.splice(0, this.maxItems));
    }, this.emitInterval);

    if (!items.length) return;

    await this.action(items);
  }

  add(data: T): void {
    this.buffer.push(data);

    if (this.buffer.length >= this.maxItems) {
      this.cleanup();
    }
  }

  async cleanup(): Promise<void> {
    const items = this.buffer.splice(0, this.maxItems);
    await this.flush(items);
  }
}
